import { createNavigation } from '@jd/i18n';

export const { redirect, usePathname, useRouter } = createNavigation({
  locales: ['en', 'pl'] as string[],
  defaultLocale: 'en',
  localePrefix: 'as-needed',
});

export const getLinkComponent = (locale = 'en') => {
  const { Link } = createNavigation({
    locales: ['en', 'pl'] as string[],
    defaultLocale: locale,
    localePrefix: 'as-needed',
  });
  return Link;
};
